import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../Assets/logo.png";
import "./Header.css";
import { AiOutlineMenu } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import { useAccount, useBalance, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import { Link } from "react-router-dom";

export default function Header() {
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address } = useAccount();
  const { open } = useWeb3Modal();

  const [scrolled, setScrolled] = useState(false);

  // Handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  return (
    <div>
      <Navbar
        collapseOnSelect
        expand="lg"
        className={`newbar ${scrolled ? "scrolled" : ""}`}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className='text-white'>
          Bitrock Wallet
            {/* <img src={logo} alt="" /> */}
          </Navbar.Brand>
          <span className="d-block d-lg-none" onClick={() => setShow(!show)}>
            {show ? (
              <>
                <RxCross2 className="text-white fs-1" />{" "}
              </>
            ) : (
              <>
                <AiOutlineMenu className="text-white fs-1" />
              </>
            )}
          </span>
          {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className={show ? "show" : ""}
          >
            <Nav className="m-auto">
              <Nav.Link as={Link} to="/" onClick={handleClose}>
                HOme
              </Nav.Link>
              <Nav.Link href="#about" onClick={handleClose}>
                About
              </Nav.Link>
              <Nav.Link  as={Link} to="/Staking"  rel="noopener noreferrer"  onClick={handleClose}>
            
            Staking
             
              </Nav.Link>
              {/* <Nav.Link  as={Link} to="/CheckWallet"  rel="noopener noreferrer"  onClick={handleClose}>
            
             Check Wallet
             
              </Nav.Link> */}
              {/* <Nav.Link href="#roadmap" onClick={handleClose}>
                Roadmap
              </Nav.Link>

              <Nav.Link href="#faq" onClick={handleClose}>
                FAQ
              </Nav.Link> */}
            </Nav>
            <Nav>
              <div className="bithu_menu_right_buttons">
                {/* <button className="join_btn hov_shape_show">
                  <img
                    src="assets/images/dis_logo.svg"
                    className="me-2"
                    alt=""
                  />
                  Join
                  <span className="hov_shape1">
                    <img src="assets/images/hov_shape_s.svg" alt="" />
                  </span>
                  <span className="hov_shape2">
                    <img src="assets/images/hov_shape_s.svg" alt="" />
                  </span>
                  <span className="square_hov_shape" />
                </button>  */}
                <button className="menu_bar">
                  <i className="fa-solid fa-bars" />
                </button>
                <div className="connect-btn-wrapper">
                  <button
                    className="connect_btn hov_shape_show"

                    onClick={() =>
                      address
                        ? chain?.id == chains[0]?.id
                          ? open()
                          : switchNetwork?.(chains[0]?.id)
                        : open()
                    }
                  >
                    <img src="assets/images/connect_wallet.svg" alt="" />
                    {address ? (
                      chain?.id == chains[0]?.id ||
                      chain?.id == chains[1]?.id ? (
                        address ? (
                          <>
                            {`${address?.substring(
                              0,
                              6
                            )}...${address?.substring(address.length - 4)}`}
                          </>
                        ) : (
                          <>CONNECT</>
                        )
                      ) : (
                        "Switch NetWork"
                      )
                    ) : (
                      <>CONNECT</>
                    )}

                    <span className="hov_shape1">
                      <img src="assets/images/hov_shape_s.svg" alt="" />
                    </span>
                    <span className="hov_shape2">
                      <img src="assets/images/hov_shape_s.svg" alt="" />
                    </span>
                    <span className="square_hov_shape" />
                  </button>
                </div>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}
